import { useQuery } from '@tanstack/react-query';
import { useUser } from '~/shared/auth/useUser';
import { fetchEmployeeDetailsByEmployeeId } from './employee.api';

export const GET_EMPLOYEE_DETAILS_QUERY_KEY = 'getEmployeeDetails';

const MS_PER_SEC = 1000;
const SEC_PER_MIN = 60;
const STALE_TIME_MINUTES = 5;

export function useEmployeeDetails() {
  const user = useUser();
  const employeeId = user.employeeId || '';

  return useQuery({
    queryKey: [GET_EMPLOYEE_DETAILS_QUERY_KEY, employeeId],
    queryFn: async () => {
      if (!employeeId) return null;
      const response = await fetchEmployeeDetailsByEmployeeId(employeeId);
      return response;
    },
    staleTime: MS_PER_SEC * SEC_PER_MIN * STALE_TIME_MINUTES,
  });
}
